if (process.env.NODE_ENV === 'development') {
    require('preact/debug');
}
import MicroModal from 'micromodal';
import {IframeResizer} from './plugins/IframeResizer';
import {init as initWishlist} from './stores/wishlist';
import {modalConfig} from './utils/modal';
import {pluginsLoader} from './utils/pluginsLoader';
import './components/webComponents';

// Load all SVGs to combine them into a sprite
require.context('../images/svg', true, /\.svg$/);

initWishlist();

document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init(modalConfig);

    pluginsLoader();

    new IframeResizer().bind(window);

    const footerMenu = document.querySelector('#institut-list');
    if ( footerMenu ) {
      let items = footerMenu.querySelectorAll('ul .menu-item');
      Array.from(items).forEach( item => {
        if ( item.classList.contains("didomi-sdk-show-settings") ) {
          let link = item.querySelector('a');
          link.setAttribute('onclick', 'javascript:Didomi.preferences.show()');
        }
      });
    }

});
